module.exports = __webpack_public_path__ + "img/code-jquery-xs.601e343a.webp";